export default "__VITE_ASSET__BGZygOJY__"